export default "__VITE_ASSET__DfVSp4G6__"